<template>
  <div class="marketplace">
    <a-spin :spinning="loading">
      <a-row :gutter="[16, 16]" v-if="!loading">
        <a-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="8"
          :xl="8"
          v-for="item in marketplaceItems"
          :key="item.id">
          <a-card hoverable class="marketplace-item-card" @click="navigateToItem(item)">
            <a-card-meta :title="item.name" :description="item.dsc">
              <template #avatar>
                <div class="category-icon">
                  <img
                    v-if="item.icon"
                    :src="item.icon"
                    alt="icon"
                    @error="handleImageError($event)" />
                  <AppstoreOutlined v-else class="default-icon" />
                </div>
              </template>
            </a-card-meta>
          </a-card>
        </a-col>
      </a-row>
      <a-row justify="center" style="margin-top: 20px;">
        <a-col :span="24" style="display: flex; justify-content: center;">
          <router-link to="/marketplace/apps">
            <a-button type="primary" size="large" style="padding: 0 50px">
              Bütün Uygulamaları Gör
            </a-button>
          </router-link>
        </a-col>
      </a-row>
      <a-empty v-if="!loading && marketplaceItems.length === 0" />
    </a-spin>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { csPortalApi } from '@/utils/csPortal'
import { AppstoreOutlined } from '@ant-design/icons-vue'

export default {
  name: 'MarketPlaceView',
  components: {
    AppstoreOutlined
  },
  setup () {
    const loading = ref(false)
    const marketplaceItems = ref([])

    const fetchData = async () => {
      loading.value = true
      try {
        const response = await axios.get(`${csPortalApi()}/marketplace/categories`)
        marketplaceItems.value = response.data
      } catch (error) {
        console.error('Error fetching marketplace data:', error)
      } finally {
        loading.value = false
      }
    }

    const navigateToItem = (item) => {
      window.location.hash = '#/marketplace/' + item.slug
    }

    const handleImageError = (event) => {
      event.target.style.display = 'none'
    }

    onMounted(fetchData)

    return { loading, marketplaceItems, fetchData, navigateToItem, handleImageError }
  }
}
</script>

<style scoped>
.marketplace-item-card {
  min-height: 120px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #e8e8e8;
}
.marketplace-item-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: #d0d0d0;
}
.category-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.category-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.default-icon {
  font-size: 32px;
  color: #1890ff;
}
</style>
